/**
 * Utility to unescape HTML entities.
 * Decodes &lt; to <, &gt; to >, &amp; to &, etc.
 * Useful when the database returns escaped HTML that needs to be rendered as rich text.
 */
export function unescapeHtml(str: string | undefined | null): string {
    if (!str) return '';
    return str
        .replace(/&lt;/g, '<')
        .replace(/&gt;/g, '>')
        .replace(/&amp;/g, '&')
        .replace(/&quot;/g, '"')
        .replace(/&#39;/g, "'")
        .replace(/&nbsp;/g, ' ');
}
